import cx from "classnames";
import { useState } from "react";

import { Button, DatePicker, Flex, LabelWrapper, Text } from "@theorgchartdev/storybook";
import { DeltaReportModal } from "./DeltaReportModal";
import { LANGUAGE_TO_DATE_LOCALE } from "@/Utils/Constants";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";
import { enumLanguage } from "@coreapp/constants";

export const PointInTimeControls = props => {
  const [showDeltaReport, setShowDeltaReport] = useState(false);

  const handleOpenDeltaReport = () => setShowDeltaReport(true);
  const handleCloseDeltaReport = () => setShowDeltaReport(false);

  const datePickerProps = (ariaLabel, dataTestId) => {
    return {
      placeholderText: appstr("None"),
      buttonProps: {
        iconProps: {
          name: "calendar"
        },
        iconAlignEnd: true,
        ariaLabel: ariaLabel,
        dataTestId: dataTestId
      },
      locale:
        LANGUAGE_TO_DATE_LOCALE[Globals._stringMgr?.GetCurrentLanguage() ?? enumLanguage.english]
    };
  };

  let dateToProps = datePickerProps("Date to", "pit-nav-date-to-picker");
  let dateFromProps = datePickerProps("Date from", "pit-nav-date-from-picker");

  return (
    <>
      <Flex
        className="ocn-file-manager-folder-table"
        flex="initial"
        overflow="visible"
        direction="column"
        gap="12px"
        padding={"12px 16px"}
      >
        <Flex direction="column" gap="4px">
          <Text size="small" modifier="bold">
            {appstr("Chart archives")}
          </Text>
          <Text size="small">
            {appstr("Choose an archive to build off of or create a delta report between two dates")}
          </Text>
        </Flex>
        <Flex direction="row" alignItems="end" justifyContent="space-between" gap="8px">
          <Flex direction="row" gap="8px">
            <LabelWrapper label={appstr("Date from")}>
              <DatePicker
                selected={props.dateMgr.dateFrom}
                onChange={props.dateMgr.setDateFrom}
                {...dateFromProps}
              />
            </LabelWrapper>
            <LabelWrapper label={appstr("Date to")}>
              <DatePicker
                selected={props.dateMgr.dateTo}
                onChange={props.dateMgr.setDateTo}
                {...dateToProps}
              />
            </LabelWrapper>
          </Flex>
          <Button
            onClick={handleOpenDeltaReport}
            iconProps={{ name: "arrow-up-right-from-square" }}
            className={cx("oc-special-secondary", "oc-special-secondary--medium")}
            modifier={"secondary"}
            dataTestId="chart-mode-explorer-pit-delta-report-btn"
          >
            {appstr("deltareport")}
          </Button>
        </Flex>
      </Flex>
      {showDeltaReport && <DeltaReportModal chart={props.chart} onClose={handleCloseDeltaReport} />}
    </>
  );
};
